<div class="page" [@routerAnimations]="prepareRouteTransition(outlet)">
    <router-outlet #outlet="outlet" class="page-outlet"></router-outlet>
</div>